import { render } from "./AdminWorkflowDetailsPage.vue?vue&type=template&id=6c008788&scoped=true"
import script from "./AdminWorkflowDetailsPage.vue?vue&type=script&lang=js"
export * from "./AdminWorkflowDetailsPage.vue?vue&type=script&lang=js"

import "./AdminWorkflowDetailsPage.vue?vue&type=style&index=0&id=6c008788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c008788"]])

export default __exports__